var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5339 3.66944C34.7868 3.59599 35.0291 3.81284 34.9838 4.07201L29.464 35.6588C29.4474 35.7541 29.4159 35.8012 29.3894 35.8313C29.3558 35.8693 29.3022 35.9086 29.2301 35.9336C29.1579 35.9586 29.0915 35.9609 29.0415 35.9518C29.0021 35.9447 28.9482 35.9271 28.876 35.8626L3.58007 13.2271C3.50794 13.1626 3.48455 13.111 3.47308 13.0726C3.45857 13.024 3.45356 12.9577 3.4705 12.8833C3.48744 12.809 3.52066 12.7514 3.55478 12.7139C3.58176 12.6842 3.62519 12.6478 3.71818 12.6208L34.5339 3.66944Z",
    fill: "#D26556",
    stroke: "#D26556",
    strokeWidth: 6.40313
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle2);
export default __webpack_public_path__ + "static/media/triangle-2.aa88b024ba8dec50444a45a3e0ada7ee.svg";
export { ForwardRef as ReactComponent };